import { CHECK_TOKEN_INTERVAL_TIME } from '@/constants/config';
import { STORAGE_KEY } from '@/constants/storage';
import jwtDecode from 'jwt-decode';

export default {
    data() {
        return {
            intervalCheckCookie: null,
        };
    },
    mounted() {
        this.checkCookieInterval();
    },
    beforeDestroy() {
        clearInterval(this.intervalCheckCookie);
    },
    methods: {
        logout(redirect = true) {
            clearInterval(this.intervalCheckCookie);
            this.$store.dispatch('auth/logout', {
                redirect,
                needContinueUrl: false,
            });
        },
        checkCookieInterval() {
            clearInterval(this.intervalCheckCookie);
            this.intervalCheckCookie = setInterval(() => {
                const token = this.$helpers.cookieParse(
                    this.$cookies.get(STORAGE_KEY.ACCESS_TOKEN)
                );
                if (token) {
                    let decoded;
                    try {
                        const refreshToken = this.$helpers.cookieParse(
                            this.$cookies.get(STORAGE_KEY.REFRESH_TOKEN)
                        );
                        if (!refreshToken) {
                            this.logout();
                        }
                        decoded = jwtDecode(token);
                        if (
                            !decoded ||
                            decoded.username !== this.user?.username
                        ) {
                            void this.$store.dispatch('auth/fetchUser');
                        }
                    } catch {
                        this.logout();
                    }
                } else {
                    this.logout();
                }
            }, CHECK_TOKEN_INTERVAL_TIME);
        },
    },
};
